<template>
	<div class="share">
		<div v-if="eligibleForExtra">
			<img :src="lightboxHeaderImage" alt="">
			<red-title>Share to increase your chance of winning!</red-title>
			<p>Simply share Japan's colourful moments with family &amp; friends to receive two more bonus entries!</p>
			<a href="#" :class="{'share__icon': true, 'share__icon--fb': true, 'used': isFacebookExtraUsed }" @click.prevent="addExtra('facebook'); facebookShare();">Share on Facebook for 1+ entry!</a>
			<a :href="mailto" :class="{'share__icon': true, 'share__icon--email': true, 'used': isEmailExtraUsed }" @click="addExtra('email')">Share via email for 1+ entry!</a>
		</div>
		<div v-else>
			<red-title>Your entry has been successfully submitted!</red-title>
			<p>Now that you've watched the {{ $root.activeMoment }} experience, you can enter again by watching the {{ $root.missingMoment }} experience to increase your chance of winning!</p>
			<div :class="{'get-extra': true, 'get-extra--ocean': $root.missingMoment === 'ocean', 'get-extra--forest': $root.missingMoment === 'forest'}">
				<div>
					<red-button aligned="right" @click.native="reopen" v-if="!eligibleForExtra">Watch <img :src="headingIcon" class="red-button__icon"> <img :src="headingCopy" class="red-button__copy"></red-button>
					<strong>+1 extra entry</strong>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import * as constants from '../constants';
import RedButton from './RedButton';
import RedTitle from './RedTitle';

export default {
	components: { RedButton, RedTitle },
	data () {
		return {
			facebookExtraUsed: false,
			emailExtraUsed: false,
		};
	},
	computed: {
		eligibleForExtra: () => Boolean(localStorage.getItem('ocean') && localStorage.getItem('forest')),
		headingCopy: function () { return require(`../assets/heading-${this.$root.missingMoment}.svg`); },
		headingIcon: function () { return require(`../assets/ico-${this.$root.missingMoment}.svg`); },
		isFacebookExtraUsed: function () { return this.facebookExtraUsed || localStorage.getItem('extra_facebook') === 'yes'; },
		isEmailExtraUsed: function () { return this.emailExtraUsed || localStorage.getItem('extra_email') === 'yes'; },
		lightboxHeaderImage: function () { return require(`../assets/header-lightbox-${this.$root.activeMoment}.jpg`); },
		mailto: () => {
			return 'mailto:?subject=Have you seen Japan\'s colourful moments?&' +
					'body=There\'s nothing more iconic than the neon streets of Japan\'s big cities or the pink blanket of cherry blossoms that sweeps the nation in spring.' +
					'%0D%0A' +
					'%0D%0A' +
					'But take a step back and you\'ll discover many more moments that are equally breathtaking.' +
					'%0D%0A' +
					'%0D%0A' +
					'See how all the colourful moments come together for your chance to win a holiday in Japan for two!' +
					'%0D%0A' +
					'%0D%0A' +
					'https://goo.gl/sBdHL7';
		},
	},
	methods: {
		reopen (e) {
			e.preventDefault();
			this.updateEntriesCount();
			this.$root.dispatchEvent('watchOther', {type: this.$root.missingMoment});
			this.$emit('reopen');
		},
		addExtra (type) {
			localStorage.setItem(`extra_${type}`, 'yes');
			if (type === 'facebook' && !this.facebookExtraUsed) {
				this.facebookExtraUsed = true;
				this.$root.dispatchEvent('share', {type: 'facebook'});
				this.updateEntriesCount();
			}
			if (type === 'email' && !this.emailExtraUsed) {
				this.emailExtraUsed = true;
				this.$root.dispatchEvent('share', {type: 'email'});
				this.updateEntriesCount();
			}
		},
		updateEntriesCount () {
			const formData = {
				entry: localStorage.getItem('submitted'),
				fields: {
					entries: parseInt(localStorage.getItem('entries')) + 1,
				},
			};
			axios.post(`${constants.API_URL}/update/`, formData)
			.then((response) => {
				const entries = parseInt(localStorage.getItem('entries'));
				localStorage.setItem('entries', entries + 1);
			});
		},
		facebookShare: () => {
			const appId = '229878890886177';
			const popupWidth = 900;
			const popupHeight = 500;

			const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
			const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
			const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
			const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
			const left = ((width / 2) - (popupWidth / 2)) + dualScreenLeft;
			const top = ((height / 2) - (popupHeight / 2)) + dualScreenTop;

			const url = `https://www.facebook.com/dialog/share?` +
					`app_id=${appId}` +
					`&display=popup` +
					`&href=${window.location.href}` +
					`&redirect_uri=${window.location.href}`;

			window.open(url, 'Facebook Share', `menubar=no, toolbar=no, location=no, scrollbars=yes, width=${popupWidth}, height=${popupHeight}, top=${top}, left=${left}`);
		},
	},
};
</script>


<style lang="less" scoped>
	@import (reference) '../assets/_mixins.less';
	@import (reference) '../assets/_breakpoints.less';

	h2 { padding-top: 70px}
	img + h2 { padding-top: 0; }

	p { max-width: 410px; margin: 0 auto 2em; font-size: 14px; text-align: center;  }
	a { margin-bottom: 2em;
		&.share__icon { position: relative; display: block; max-width: 50%; margin-left: auto; margin-right: auto; font-size: 14px; text-align: center;
			&--fb:before { .top-left(-8px); content: ""; display: inline-block; .size(28px); margin-right: 17px; .bg('../assets/ico-fb.svg', 0 0 / contain); }
			&--email:before { .top-left(-5px); content: ""; display: inline-block; .size(28px); margin-right: 17px; .bg('../assets/ico-email.svg', 0 0 / contain); }
			&.used { opacity: .5; }
		}
	}
	.get-extra { display: flex; justify-content: center; align-items: center; min-width: 575px; min-height: 194px; height: 194px; margin-top: 70px;
		div { flex-grow: 1; width: 100%; max-width: 245px; }
		a { max-width: unset; padding-left: 0; margin: 0; box-shadow: 1px 0px 20px 10px rgba(0, 0, 0, .2);
			&:after { margin-left: 0; margin-right: 10px; }
			img.red-button__icon { width: 20px; margin: 0 2px 0 4px; vertical-align: middle; }
			img.red-button__copy { width: 70px; vertical-align: middle; transform: translateY(-3px); }
		}
		strong { display: block; margin-top: 17px; color: white; text-align: center; text-shadow: 1px 0px 20px rgb(0, 0, 0); }

		&--ocean { .bg('../assets/confirmation-ocean.jpg', 0 0 / cover);
			a img.red-button__icon { width: 40px; }
		}
		&--forest { .bg('../assets/confirmation-forest.jpg', 0 0 / cover);
			a img.red-button__icon { margin: 0 10px 0 10px; }
		}
	}

	@media @mobile {
		img + h2 { max-width: 85%; margin: 20px auto; }
		p { max-width: 85%; text-align: left; }
		a.share__icon { max-width: 85%; }
		.get-extra { min-width: unset; }
	}
</style>



// WEBPACK FOOTER //
// src/components/TheLightboxConfirmation.vue